import React from 'react'

export function ApoloProgressBar({
  className = '',
  lineClassName = '',
  bgColor,
  mainColor,
  percentage,
}) {
  return (
    <div className={`${bgColor} h-2 w-full rounded-sm ${className}`}>
      <div
        className={`${mainColor} h-full ${percentage == 100 ? 'rounded-sm' : 'rounded-l-sm'} ${lineClassName}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  )
}
